import { combineReducers } from 'redux';

import monitorings from './monitorings';

const reducer = combineReducers({
  [monitorings.name]: monitorings.reducer,
});

export default reducer;
